<template>
  <v-row id="static-page__custom-code">
    <v-col cols="12">
      <h2>Custom Code</h2>
    </v-col>
    <v-col cols="12" sm="4">
      <v-textarea
        data-testid="static-page-markup-head-textarea"
        class="static-page-markup-head-textarea"
        label="Custom Markup (head)"
        filled
        hint="Code in this box will be injected right before the closing head tag on this page"
        v-model.trim="currentStaticPage.custom_markup_head"
        clearable
      />
    </v-col>
    <v-col cols="12" sm="4">
      <v-textarea
        data-testid="static-page-markup-body-textarea"
        class="static-page-markup-body-textarea"
        label="Custom Markup (body)"
        filled
        hint="Code in this box will be injected right before the closing body tag on this page"
        v-model.trim="currentStaticPage.custom_markup_body"
        clearable
      />
    </v-col>
    <v-col cols="12" sm="4">
      <v-textarea
        data-testid="static-page-css-textarea"
        class="static-page-css-textarea"
        label="Custom CSS"
        filled
        v-model.trim="currentStaticPage.custom_css"
        clearable
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  computed: {
    currentStaticPage: {
      get() {
        return this.$store.state.staticPage.currentStaticPage;
      },
      set(newValue) {
        this.$store.commit("setCurrentStaticPageData", newValue);
      }
    }
  }
};
</script>
